import { loadCarousels } from '@/utils/Controllers/CarouselController';

document.addEventListener('DOMContentLoaded', () => {
  loadCarousels();
});
